import React from "react";
import { Images } from "../assets";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  // Reusable FooterLinks component
  const FooterLinks = ({ title, links = [] }) => (
    <div className="text-start">
      <h4 className="text-lg uppercase tracking-wider">{title}</h4>
      <div className="border border-white mt-2 w-[5rem]"></div>
      {links.length > 0 && (
        <ul className="flex flex-col gap-4 mt-8">
          {links.map((link, index) => (
            <li key={index} className="text-sm text-white/50">
              <a
                href={link.url}
                className="flex items-center gap-3 hover:text-orange transition"
              >
                {link.icon && (
                  <img src={link.icon} alt="Icon" className="w-6 h-6" />
                )}
                {Array.isArray(link.text) ? (
                  <div className="flex flex-col">
                    {link.text.map((textLine, i) => (
                      <p key={i}>{textLine}</p>
                    ))}
                  </div>
                ) : (
                  <p>{link.text}</p>
                )}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );

  return (
    <footer className="bg-footer w-full px-[10%] py-10 flex flex-col gap-16 bg-[#111111] mt-20">
      {/* Logo */}
      <img src={Images.MAIN_LOGO} alt="Logo AficorSA" className="self-start" />

      {/* Responsive Links Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 w-full">
        <FooterLinks
          title={t("footer.navigation.title")}
          links={[
            { text: t("footer.navigation.home"), url: "/" },
            {
              text: t("footer.navigation.afishop"),
              url: "https://parts.aficor.ch/fr/",
            },
            { text: t("footer.navigation.ourMachines"), url: "/nos-machines" },
            { text: t("footer.navigation.aboutUs"), url: "/a-propos" },
            { text: t("footer.navigation.ourHistory"), url: "/notre-histoire" },
          ]}
        />
        <FooterLinks
          title={t("footer.services.title")}
          links={[
            { text: t("footer.services.hydraulics"), url: "/hydraulique" },
            { text: t("footer.services.oxycoupage"), url: "/oxycoupage" },
            { text: t("footer.services.rd"), url: "/r&d" },
          ]}
        />
        <FooterLinks
          title={t("footer.social.title")}
          links={[
            {
              text: t("footer.social.facebook"),
              url: "https://www.facebook.com/share/1B3Peh7Cq4/",
              icon: Images.FACEBOOK,
            },
            {
              text: t("footer.social.instagram"),
              url: "https://www.instagram.com/aficor_sa_officiel?igsh=MXF5dDYxM3RidWhoZw==",
              icon: Images.INSTAGRAM,
            },
            {
              text: t("footer.social.youtube"),
              url: "http://www.youtube.com/@aficorsa",
              icon: Images.YOUTUBE,
            },
          ]}
        />
        <FooterLinks
          title={t("footer.contact.title")}
          links={[
            {
              text: [
                t("footer.contact.address.line1"),
                t("footer.contact.address.line2"),
              ],
              url: "https://www.google.com/maps?q=Route+du+Village+1,+1409+Chanéaz,+Suisse",
              icon: Images.LOCATION,
            },
            {
              text: t("footer.contact.phone"),
              url: "tel:+41244331124",
              icon: Images.PHONE,
            },
            {
              text: t("footer.contact.email"),
              url: "mailto:info@aficor.ch",
              icon: Images.MAIL,
            },
          ]}
        />
      </div>

      {/* Bottom Section */}
      <div className="flex flex-col md:flex-row items-center justify-between w-full gap-4">
        <p className="text-sm tracking-wider text-white/50">
          © 2024 {t("footer.rightsReserved")}
        </p>
        <div className="flex gap-3 items-center italic text-base">
          <img src={Images.WIP} alt="Marteau" className="w-6 h-6" />
          {t("footer.designedBy")}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
